import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/copy-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-959be590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid p-flex-wrap p-flex-column" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "p-grid p-flex-wrap" }
const _hoisted_4 = { class: "p-d-flex p-justify-center p-flex-wrap p-grid p-col-12 p-md-7 main-upload-block" }
const _hoisted_5 = {
  key: 0,
  class: "main-photo p-col-4"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "p-d-flex p-flex-column p-col-7" }
const _hoisted_8 = { class: "p-d-flex p-flex-wrap" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src", "onClick"]
const _hoisted_11 = { class: "name-photo" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-photo" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "crosshair-line" }),
  /*#__PURE__*/_createElementVNode("span", { class: "cover-text" }, "Upload thumbnail")
], -1))
const _hoisted_13 = { class: "p-d-flex p-flex-column w-100 p-ml-4 p-mt-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Content URL", -1))
const _hoisted_15 = { class: "p-mr-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_17 = { class: "p-col-12 p-md-4 p-mt-3 p-mt-md-0 edit-info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Content ttitle", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Content Description", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecretTip = _resolveComponent("SecretTip")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createTextVNode("Content Piece " + _toDisplayString($props.number + 1) + " ", 1),
      _createElementVNode("i", {
        class: "pi pi-trash remove-icon",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.removeItem && $setup.removeItem(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        ($setup.activeIndex >= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                src: $setup.allPhotos[$setup.activeIndex],
                class: "main-photo-img",
                alt: "Campaign logo"
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_SecretTip, {
            style: {"margin":"20px 0 35px 0"},
            text: 'Upload a nice image for your content to make it more wanted'
          }),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allPhotos, (photo, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "p-d-flex p-flex-wrap p-flex-column p-mb-3 relative-block"
              }, [
                ($setup.allPhotos.length > 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "delete-icon",
                      onClick: ($event: any) => ($setup.removePhoto(index))
                    }, "X", 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("img", {
                  src: photo,
                  alt: "video image",
                  class: _normalizeClass(["photos", [$setup.activeIndex === index ? 'active-photo' : '']]),
                  onClick: ($event: any) => ($setup.activePreview(index))
                }, null, 10, _hoisted_10),
                _createElementVNode("h5", _hoisted_11, _toDisplayString($setup.namesPhotos[index]), 1)
              ]))
            }), 128)),
            _createElementVNode("label", null, [
              _createElementVNode("input", {
                type: "file",
                name: "photo",
                accept: "image/*",
                ref: "uploadPhotoInput",
                style: {"visibility":"hidden","display":"none"},
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleFileUpload && $setup.handleFileUpload(...args)))
              }, null, 544),
              _hoisted_12
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", {
            class: "copy-url",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.copyLink($props.item.url)))
          }, [
            _createElementVNode("span", _hoisted_15, _toDisplayString($props.item.url), 1),
            _hoisted_16
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_InputText, {
          class: "w-100",
          type: "text",
          modelValue: $setup.contentTittle,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.contentTittle) = $event)),
          placeholder: "Enter your desired title"
        }, null, 8, ["modelValue"]),
        _hoisted_19,
        _createVNode(_component_Textarea, {
          modelValue: $setup.contentDescription,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.contentDescription) = $event)),
          "auto-resize": false,
          rows: "11",
          class: "w-100 textarea-desc",
          placeholder: "Enter your description"
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}